import { Coordenada } from './taxa-entrega';
import { cepFormata } from './endereco';

// O que o GPS consegue preencher. Sai sempre parcial: nenhum provedor devolve
// complemento, e o numero so vem quando o ponto cai sobre um imovel mapeado.
export type LocalizacaoEndereco = {
  logradouro: string;
  numero: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
  latitude: number;
  longitude: number;
};

// O Photon devolve `state` por extenso ("Ceará") e o endereco quer a sigla. A tabela fica
// aqui, e nao em `aps://uniao/uf`, porque este modulo e puro e aquilo e assincrono.
const UF_POR_ESTADO: Record<string, string> = {
  'acre': 'AC',
  'alagoas': 'AL',
  'amapa': 'AP',
  'amazonas': 'AM',
  'bahia': 'BA',
  'ceara': 'CE',
  'distrito federal': 'DF',
  'espirito santo': 'ES',
  'goias': 'GO',
  'maranhao': 'MA',
  'mato grosso': 'MT',
  'mato grosso do sul': 'MS',
  'minas gerais': 'MG',
  'para': 'PA',
  'paraiba': 'PB',
  'parana': 'PR',
  'pernambuco': 'PE',
  'piaui': 'PI',
  'rio de janeiro': 'RJ',
  'rio grande do norte': 'RN',
  'rio grande do sul': 'RS',
  'rondonia': 'RO',
  'roraima': 'RR',
  'santa catarina': 'SC',
  'sao paulo': 'SP',
  'sergipe': 'SE',
  'tocantins': 'TO',
};

function semAcento(texto: string): string {
  return (texto || '')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .trim()
    .toLowerCase();
}

// Aceita nome por extenso ou sigla: o provedor varia conforme o zoom do ponto.
export function ufDeEstado(estado: string): string {
  const limpo = semAcento(estado);
  if (!limpo) {
    return '';
  }
  if (limpo.length === 2) {
    return limpo.toUpperCase();
  }
  return UF_POR_ESTADO[limpo] || '';
}

// Devolve null sem feicao - diferente de endereco vazio: a tela avisa em vez de limpar
// o que o cliente ja digitou.
export function localizacaoDePhoton(resposta: any, coordenada: Coordenada): LocalizacaoEndereco | null {
  const feicao = resposta?.features?.[0];
  if (!feicao) {
    return null;
  }
  const p = feicao.properties || {};
  return {
    logradouro: p.street || p.name || '',
    numero: p.housenumber || '',
    bairro: p.district || p.suburb || '',
    cidade: p.city || p.county || '',
    uf: ufDeEstado(p.state),
    cep: cepFormata(p.postcode || ''),
    latitude: coordenada?.latitude,
    longitude: coordenada?.longitude,
  };
}
